import { Client } from "../../clients/client";
import { PaginationForm, Pagination } from "@/common/mixins/pagination";

import { Shopify } from "./models/Shopify";
import { ShopifyCreateForm } from "./forms/ShopifyCreateForm";
import { ShopifyUpdateForm } from "./forms/ShopifyUpdateForm";
import { shopifyUseCase } from "@/dependencies";

export class ShopifyUseCase {
  constructor(private client: Client) {}

  public async createShopify(form: ShopifyCreateForm): Promise<Shopify> {
    return this.client.shopify.postShopify({
      ...form,
      shopId: form.shop?.id!,
      deliveryModeId: form.deliveryMode?.id!
    });
  }
  public async getShopify(form: PaginationForm): Promise<Pagination<Shopify>> {
    return this.client.shopify.getShopify({
      page: form && form.page,
      limit: form && form.perPage
    });
  }

  public async getShopifyById(id: number): Promise<Shopify> {
    return this.client.shopify.getShopifyById(id);
  }

  public async updateShopify(
    id: number,
    form: ShopifyUpdateForm
  ): Promise<Shopify> {
    return this.client.shopify.patchShopify(id, {
      ...form,
      deliveryModeId: form.deliveryMode?.id!
    });
  }

  public async deleteShopify(id: number): Promise<Shopify> {
    return this.client.shopify.deleteShopify({ id });
  }

  async syncProductByShopId(id: number) {
    return this.client.shopify.postShopifyProductSyncByShopId(id);
  }

  async syncStockByShopId(id: number) {
    return this.client.shopify.postShopifyStockSyncByShopId(id);
  }
}
